import { createStore }      from 'redux';
import { api as KirokuAPI } from './middleware-redux/index';
import reducers             from './reducers'

export default createStore(reducers, KirokuAPI);
